import { render } from "./WrongLetters.vue?vue&type=template&id=22367cd2&scoped=true"
import script from "./WrongLetters.vue?vue&type=script&lang=js"
export * from "./WrongLetters.vue?vue&type=script&lang=js"

import "./WrongLetters.vue?vue&type=style&index=0&id=22367cd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-22367cd2"

export default script